import React from 'react'
import { Link } from 'react-router'
import { Routes } from '../../routes/routes'

export const Forbidden = () => {
  return (
    <div className="card shadow-sm">
      <div className="card-body">
        <h5 className="card-title">Forbidden</h5>
        <p className="card-text">You do not have permission to access this page.</p>
        <Link className="btn btn-primary" to={Routes.DashboardOverview.path}>
          Back to Overview
        </Link>
      </div>
    </div>
  )
}
